window.AddressLookup = {
    onBegin: function () {
        $(this).find('.input-loader').addClass('input-loader--on');
    },
    onComplete: function () {
        $(this).find('.input-loader').removeClass('input-loader--on');
    }
}